export const Browser = {
  _Chrome: 'chrome',
  _Edge: 'edge',
  _Safari: 'safari',
  _Firefox: 'firefox',
  _Other: 'other',
} as const;
